var map = {
	"./index.es.js": 400,
	"./modifiers.js": 403
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;


//////////////////
// WEBPACK FOOTER
// ../common/dependencies (\/|\\)(?!_)[\w\.\-\\]+\.js$
// module id = 399
// module chunks = 2